// extracted by mini-css-extract-plugin
module.exports = {"title":"FormStep_title__IaoRk","buttons":"FormStep_buttons__l47Ey","rotation":"FormStep_rotation__2Of7w"};